import { DefaultSubMenuItems } from '@dpr-details/enums';
import { StaticMessage } from '@shared/enums';
import { NavigationMenuItem } from '@shared/models';
import { getStaticMessage } from '../../shared/utils';

export function getDefaultSubMenuItems(): NavigationMenuItem[] {
  return [
    {
      id: 1,
      label: getStaticMessage(StaticMessage.RegistrationsLabel),
      link: DefaultSubMenuItems.Registrations,
    },
    {
      id: 2,
      label: getStaticMessage(StaticMessage.AttachmentsLabel),
      link: DefaultSubMenuItems.Attachments,
    },
    {
      id: 3,
      label: getStaticMessage(StaticMessage.CommentLabel),
      link: DefaultSubMenuItems.Comment,
    },
  ];
}
